import React from "react";
import { FiShoppingCart, FiSettings, FiTrendingUp, FiSmartphone, FiGlobe, FiZap, FiLayers, FiUsers, FiCode, FiShield } from "react-icons/fi";
import {
  LuSettings,
  LuUsers,
  LuSmartphone,
  LuShieldCheck,
  LuPercent,
  LuShield,
  LuBuilding2,
  LuShoppingBag,
  LuClock,
  LuWallet,
  LuCpu,
  LuClipboardList,
  LuPalette,
  LuCode,
  LuBug,
  LuRocket,
} from "react-icons/lu";

// 1. Hero Block Configuration
export const shopifyDevelopmentHeroData = {
  backgroundImage: "/images/serviceBanners/ShopifyBanner.webp",
  whiteImage: "/images/serviceBanners/SHOPIFYW.webp",
  subTitle: "Creating High-Converting Shopify eCommerce Stores",
  title: (
    <>
      Launch & Scale <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Shopify Stores</span> <br /> with High-Converting Solutions
    </>
  ),
  description:
    "Shopify stores designed for speed, responsiveness, and conversion focused performance that enhance shopping experience, streamline store management, and help businesses increase online sales through optimized eCommerce solutions.",
  primaryButton: {
    title: "Start Your Store",
    onClick: () => console.log("Shopify Start clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "High Performance",
      desc: "Fast and optimized Shopify store performance.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Responsive Design",
      desc: "Perfect shopping experience on all devices.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Secure & Reliable",
      desc: "Built with strong security and stable architecture.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Clean Code",
      desc: "Maintainable and developer-friendly Shopify development.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "6%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(149,190,70,0.35)", // Shopify Greenish-Glow
      iconGlow: "rgba(149,190,70,0.9)",
    },
  ],
};

// 2. Stats Block
export const shopifyStatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Apps Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Downloads",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Crash-Free Apps",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Development",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

// 3. Solutions & Process Block (WhyChooseUs Data)
export const shopifySolutionsAndProcessData = {
  buildSubtitle: "OUR ECOMMERCE SERVICES",
  buildTitle: "Custom Shopify Development Solutions for Every Business Need",
  buildCards: [
    {
      title: "High-Converting Store Development",
      desc: "Build fast and scalable Shopify stores focused on sales growth and performance.",
      icon: FiLayers,
      colorClass: "text-[#95bf46]",
      bgClass: "bg-[#95bf46]/10",
      borderClass: "border-[#95bf46]/20 hover:border-[#95bf46]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(149,191,70,0.25)]",
    },
    {
      title: "Enterprise Shopify Solutions",
      desc: "Develop secure and scalable eCommerce solutions for growing businesses.",
      icon: FiShield,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "E-Commerce Shopify Development",
      desc: "Create feature-rich online stores with seamless shopping experience.",
      icon: FiLayers,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "On-Demand Shopify Solutions",
      desc: "Build flexible Shopify setups for dynamic product and order management.",
      icon: FiCode,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Secure Shopify Development",
      desc: "Ensure safe, reliable, and stable eCommerce store performance.",
      icon: FiShield,
      colorClass: "text-[#34d399]",
      bgClass: "bg-[#34d399]/10",
      borderClass: "border-[#34d399]/20 hover:border-[#34d399]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(52,211,153,0.25)]",
    },
    {
      title: "Custom Shopify Solutions",
      desc: "Tailored Shopify development aligned with business goals and branding.",
      icon: FiLayers,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
  ],
  processSubtitle: "OUR DEVELOPMENT PROCESS",
  processTitle: "Shopify Development Process",
  processSteps: [
    {
      step: "01",
      title: "Discovery & Consultation",
      description: "Understand business goals, target audience, and store requirements.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Strategy & Planning",
      description: "Define Shopify features, structure, and execution roadmap.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "UI/UX Design",
      description: "Create modern, conversion-focused Shopify store designs.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: "Development",
      description: "Build scalable and high-performance Shopify stores with clean architecture.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Quality Testing",
      description: "Test performance, security, and shopping experience for smooth usability.",
      icon: LuBug,
    },
    {
      step: "06",
      title: "Deployment & Support",
      description: "Launch store and provide ongoing maintenance and improvements.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY CHOOSE OUR SHOPIFY DEVELOPMENT SERVICES?",
  benefitsTitle: "Why Businesses Choose Shopify Development Solutions",
  benefits: [
    "Cross-platform support",
    "Faster store development",
    "Modern UI design",
    "Smooth performance boost",
    "Efficient workflow process",
    "Scalable Shopify solutions",
    "Cost-effective development approach",
  ],
  logoImage: "/images/serviceBanners/ShopifyBanner.webp",
  whiteLogoImage: "/images/serviceBanners/SHOPIFYW.webp",
};

// 4. Portfolio Data
export const shopifyPortfolioData = {
  subtitle: "OUR SUCCESS STORIES",
  title: "Shopify Stores Dominating Markets",
  buttonText: "View Case Studies",
  buttonLink: "#",
  apps: [
    {
      title: "UrbanTrend Collective",
      badge: "Fashion Retail",
      badgeColor: "bg-[#95bf46]/10 text-[#95bf46] border-[#95bf46]/20",
      desc: "A custom Shopify Plus store handling 10k+ daily transactions with advanced filtering.",
      downloads: "Active",
      rating: "5.0",
      image: "https://images.unsplash.com/photo-1515168833906-d2a3b82b3029?auto=format&fit=crop&w=800&q=80",
    },
  ],
};

// 5. Technologies Data
export const shopifyTechnologiesData = {
  techTitle: "SHOPIFY ECOSYSTEM",
  technologies: [
    { name: "Liquid", icon: "Code" },
    { name: "Shopify API", icon: "RestAPI" },
    { name: "Hydrogen", icon: "ReactJS" },
    { name: "Polaris UI", icon: "Layout" },
    { name: "Node.js/Backend", icon: "Firebase" },
    { name: "GraphQL", icon: "Vite" },
  ],
  trustTitle: "POWERING TOP SHOPIFY BRANDS",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

// 6. About Overview
export const shopifyAboutData = [
  {
    title: "Shopify Development Services for High-Converting Online Stores",
    content: (
      <>
        Building a successful eCommerce store requires more than attractive visuals and product listings. Effective{" "}
        <b className="text-text-primary font-semibold">shopify development services</b> help businesses create scalable online stores that improve shopping experiences, simplify
        store management, and support long-term sales growth. Many businesses struggle with slow performance, poor navigation, and limited customization that impact customer trust.
        At <b className="text-text-primary font-semibold">Tycho Technologies</b>, Shopify stores are developed around user expectations, business goals, and performance-focused
        functionality to help brands improve conversions and customer satisfaction.
      </>
    ),
  },
  {
    title: "Shopify Ecommerce Development for Better Customer Experience",
    content: (
      <>
        Customer expectations continue to rise in online shopping, making user experience more important than ever. Reliable{" "}
        <b className="text-text-primary font-semibold">shopify ecommerce development</b> helps businesses improve navigation, simplify checkout journeys, and create smoother
        shopping experiences that encourage repeat purchases. Companies investing in <b className="text-text-primary font-semibold">custom shopify store development</b> often
        benefit from flexible store functionality designed around specific business requirements. Tycho Technologies focuses on practical Shopify strategies that support usability,
        operational efficiency, and long-term digital growth.
      </>
    ),
  },
  {
    title: "Shopify Website Development Company for Scalable Growth",
    content: (
      <>
        A growing online business needs an eCommerce platform that adapts to changing customer demands and increasing product inventory. A trusted{" "}
        <b className="text-text-primary font-semibold">shopify website development company</b> helps businesses create scalable stores designed for stronger engagement and
        sustainable performance. Organizations aiming to improve online sales often strengthen their commerce ecosystem through{" "}
        <a href="https://tychotechnologies.com/woocommerce-development-india" className="text-cyan-400 underline hover:text-cyan-300">
          woocommerce development services
        </a>{" "}
        to explore platform flexibility and support broader business expansion.
      </>
    ),
  },
  {
    title: "Why Businesses Choose a Shopify Development Company in India",
    content: (
      <>
        The demand for a trusted <b className="text-text-primary font-semibold">shopify development company in india</b> continues to grow as businesses seek reliable eCommerce
        solutions with faster deployment and flexibility. Companies working with <b className="text-text-primary font-semibold">shopify experts india</b> often prioritize
        customized functionality, better store usability, and long-term business growth. Businesses partnering with Tycho Technologies gain access to tailored Shopify solutions
        built around measurable goals and customer expectations. Many organizations also strengthen platform scalability with{" "}
        <a href="https://tychotechnologies.com/magento-development-india" className="text-cyan-400 underline hover:text-cyan-300">
          magento development services
        </a>{" "}
        to support evolving eCommerce strategies.
      </>
    ),
  },
];

// 7. FAQs
export const shopifyDevelopmentFaqs = [
  {
    q: "Why should I choose Shopify development in India for my online store?",
    a: "Shopify development in India offers cost-effective, high-quality solutions with skilled developers who ensure your store is secure, scalable, and optimized for performance.",
  },
  {
    q: "What are the benefits of Shopify development for my business?",
    a: "It allows you to create an online store quickly with user-friendly interfaces, secure payments, and extensive customization while minimizing technical hassle.",
  },
];
